import { copySpecification } from 'consts/keyboardShortcuts';
import Attribute from 'types/Attribute';
import getSerializedAttributes from 'utils/getSerializedAttributes';
import { useIntl } from 'utils/intl';
import useKeyboardShortcut from 'hooks/useKeyboardShortcut';

import messages from './ProductSpecificationKeyPress.messages';

type Props = {
  attributes: Attribute[];
};

const ProductSpecificationKeyPress = ({ attributes }: Props): JSX.Element => {
  const intl = useIntl();

  useKeyboardShortcut(copySpecification, async ({ showMessage }) => {
    if ('navigator' in window && navigator.clipboard) {
      await navigator.clipboard.writeText(getSerializedAttributes(attributes, intl.formatMessage(messages.noneValue)));
      showMessage('info', intl.formatMessage(messages.specificationCopied));
    }
  });

  return <></>;
};

export default ProductSpecificationKeyPress;
